"use strict";

AquaTechTheme.registerModule('collection-filter', null, function() {
    AquaTechTheme.CollectionFilter = {
        $: null,
        $jsDebug: null,
        CollectionFilteringForm: null,
        clipboard: null,
        DEBUG: false,
        FILTER_DISABLE_NOTICE: false,

        /******************/

        /* Collections with custom filter options: */
        CollectionTables: {
          '/collections/water-housings-lens-ports-x-series-lens-ports': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-PSeriesLensPorts.js?v=107324205540045611571792552264",
          '/collections/water-housings-zoom-gears': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-ZoomGears.js?v=32698103703933351841792552298"
        },

        /* Collections with custom filter ordering: */
        PriorityTables: {
          '/collections/water-housings': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-priority-WaterHousings.js?v=44565508164729612671791331773",
          '/collections/water-housings-canon': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-priority-WaterHousings.js?v=44565508164729612671791331773",
          '/collections/water-housings-sony': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-priority-WaterHousings.js?v=44565508164729612671791331773",
          '/collections/fujifilm-water-housings': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-priority-WaterHousings.js?v=44565508164729612671791331773",
          '/collections/water-housings-nikon': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-priority-WaterHousings.js?v=44565508164729612671791331773",
          '/collections/leica-water-housing': "//au.aquatech.net/cdn/shop/t/72/assets/AquaTechTheme-collection-filter-priority-WaterHousings.js?v=44565508164729612671791331773",
          '/collections/water-housings-lens-ports-x-series-lens-ports': 'filter'
        },

        /* Set Titles */
        subsetGroups: {
          'A' : 'Above Water',
          'OU' : 'Over/Under &amp; Underwater'
        },

        /******************/

        onDocReady: function() {
            this.$ = AquaTechTheme.$;
            var $ = this.$;

            if (CollectionFilterSpecs.fields.length !== 0) {
              this.initFilter();
            }
        },

        initFilter: function() {
            if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.initFilter'); }

            var $ = this.$;

            this.CollectionFilteringForm = customElements.get('collection-filtering-form');

            this.composeSelects();
            this.renderMetaFilters();
            this.hideBaseFilters();
            this.setMetaFilterState();
            this.watchPageRenderEvent();
            this.filterFloat();
            this.initCustomReferenceTables();
            this.initCustomPriorityTables();
            this.watchCart();
        },

        /* Populate CollectionFilterSpecs with filter structure */
        composeSelects: function() {
            if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.composeSelects'); }

            var $ = this.$;

            CollectionFilterSpecs.selects = {};
            for (var cff of CollectionFilterSpecs.fields) {
              var selector = "#main-collection-filters input[name='filter.p.m.custom." + cff + "']";
              var $select = $(selector);

              CollectionFilterSpecs.selects[cff] = {
                label: "?",
                selector: selector,
                options: []
              };
            }

            var numOpts = CollectionFilterSpecs.options.length;
            for (var cfo = 0; cfo < numOpts; cfo++) {
              var opt = CollectionFilterSpecs.options[cfo];
              var shortName = opt.param.replace('filter.p.m.custom.', '');
              CollectionFilterSpecs.selects[shortName].field = opt.param;
              CollectionFilterSpecs.selects[shortName].label = opt.filter_label;
              CollectionFilterSpecs.selects[shortName].options.push({
                label: opt.label,
                value: opt.value
              });
            }
            delete CollectionFilterSpecs.options;

            CollectionFilterSpecs.lockedIn = {};
            for (var cfa = 0; cfa < CollectionFilterSpecs.assign.length; cfa++) {
              var parts = CollectionFilterSpecs.assign[cfa].split('=');
              CollectionFilterSpecs.lockedIn[parts[0]] = parts[1];
            }

            CollectionFilterSpecs.filter_labels = {};
            var fNames = [];
            var fnum = 0;
            for (var fn in CollectionFilterSpecs.fields) {
              if (CollectionFilterSpecs.fields.hasOwnProperty(fn)) {
                fNames.push(CollectionFilterSpecs.fields[fn]);
              }
            }
            var fTitles = [];
            fnum = 0;
            for (var ft in CollectionFilterSpecs.field_titles) {
              if (CollectionFilterSpecs.field_titles.hasOwnProperty(ft)) {
                fTitles.push(CollectionFilterSpecs.field_titles[ft]);
              }
            }

            var numFilters = fNames.length;
            for (var fnt = 0; fnt < numFilters; fnt++) {
              CollectionFilterSpecs.filter_labels[fNames[fnt]] = fTitles[fnt];
            }
        },

        /* Temp deactivation message */
        showSubstituteMessage: function() {
          var $ = this.$;
          var self = this;

          var urlParts = AquaTechTheme.getUrlParts();

          console.log('filter disable check...');
          console.log(urlParts.path);

          if ($('.collection-metafilters-wrap .filter-notice').length) {
              return;
          }

          // Lens Ports Filter Not Active Message:
          if (urlParts.path == '/collections/water-housings-lens-ports-x-series-lens-ports') {
            var $subMsg = $('<p class="filter-notice">Please use our Lens Port chart <a style="text-decoration: underline; color: var(--color-primary);" href="/pages/knowledge-center">here</a> to find your lens setup. If you have any questions please send an email to contact@aquatech.net</p>');

            $(".collection-metafilters-wrap .filter-stages").after($subMsg);
            $(".collection-metafilters-wrap .filter-stages").hide();
            $(".collection-metafilters-wrap h3.prompt").html('Lens Ports');
          }
        },

        /* Insert custom filters html */
        renderMetaFilters: function() {
          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.renderMetaFilters'); }

          var $ = this.$;
          var self = this;
          var innerEl = $('<div class="collection-metafilters-wrap"></div>');
          $("#main-collection-filters").after(innerEl);

          var cmfEl = $('<div id="collection-metafilters"></div>');
          $(innerEl).append(cmfEl);
          var $mFilters = $(cmfEl);

          $mFilters.append('<div class="aq-logo"><img src="//au.aquatech.net/cdn/shop/t/72/assets/aqlogo-filter.png?v=11383050518901776071791331773" width="109" height="108" /></div>')
          $mFilters.append('<h3 class="prompt">Choose your <span>' + CollectionFilterSpecs.title + '</span></h3>');
          var sWrap = $('<div class="filter-stages"></div>');
          $mFilters.append(sWrap);
          var $sWrap = $(sWrap);

          $('.grid-area--filtering').append('<div class="product-recommendations-messages"></div>');
          $('.grid-area--filtering').append('<div class="product-recommendations"></div>');

          var prefixRegEx = /^\[(.*)\]/i;
          for (var sp in CollectionFilterSpecs.selects) {
            if (CollectionFilterSpecs.selects.hasOwnProperty(sp)) {
              var select = CollectionFilterSpecs.selects[sp];
              var $s = $('<select name="metafilter_' + sp + '"></select>');
              $sWrap.append($s);
              var selectLabel = '';
              if (CollectionFilterSpecs.filter_labels.hasOwnProperty(sp) && CollectionFilterSpecs.filter_labels[sp]) {
                selectLabel = CollectionFilterSpecs.filter_labels[sp];
              } else {
                selectLabel = select.label.replace('Fits', CollectionFilterSpecs.title);
              }
              $s.append('<option value="">' + selectLabel + '</option>');
              for (var op in select.options) {
                if (select.options.hasOwnProperty(op)) {
                  var opt = select.options[op];
                  var optLabel = opt.label;
                  var prefixMatch = optLabel.match(prefixRegEx);
                  var hasPrefix = prefixMatch !== null && prefixMatch.length > 0;
                  if (hasPrefix) {
                    optLabel = optLabel.replace('[' + prefixMatch[1] + ']', '');
                  }
                  $s.append('<option value="' + opt.value + '">' + optLabel + '</option>');
                }
              }
              $s.on('change', function() {
                self.setFilterConstraints(this);
                self.onMetaFilterStateChange();
              });
            }

            $s.select2({
              minimumResultsForSearch: Infinity,
              templateResult: function(data, container) {
                if (data.element) {
                  $(container).addClass($(data.element).attr("class"));
                }
                return data.text;
              },
            }).data('select2').$dropdown.addClass('collection-metafilter-dropdown');

            $s.on('select2:open', function() {
              //console.log('open');
              setTimeout(function() {
                var $results = $('.select2-results');
                var $firstLi = $results.find('li').first();
                $firstLi.html('All');
              }, 1);
            });
          }
        },

        /* Hide underlying meta filters */
        hideBaseFilters: function() {
          var $ = this.$;
          var self = this;

          for (var fi = 0; fi < CollectionFilterSpecs.fields.length; fi++) {
            var fname = CollectionFilterSpecs.fields[fi];
            var fdataname = fname.replaceAll('_', '-');
            $("details[data-filter-by='" + fdataname + "']").addClass('suppress');
          }
        },

        /* Inspect base filters and set available options */
        setMetaFilterState: function() {
          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.setMetaFilterState'); }

          var filteredSteps = 0;
          var filterStep = 1;
          var numSelections = 0;
          var prevStepVal = '';
          var prefixRegEx = /^\[(.*)\]/i;
          for (var sp in CollectionFilterSpecs.selects) {
            if (CollectionFilterSpecs.selects.hasOwnProperty(sp)) {
              var select = CollectionFilterSpecs.selects[sp];
              var $mfSelect = $("#collection-metafilters select[name='metafilter_" + sp + "']");
              $mfSelect.val('');
              var $baseCbs = $(select.selector);
              $baseCbs.each(function() {
                var $cb = $(this);
                var fstate = {
                  value: $cb.val(),
                  checked: $cb.is(':checked'),
                  disabled: $cb.parent().hasClass('facet-checkbox--disabled')
                };
                var $mfOpt = $mfSelect.find("option[value='" + fstate.value + "']");
                if (filterStep > 1) {
                  // Disable invalid options on filters past the first:
                  var optVal = $mfOpt.val();
                  var prefixMatch = optVal.match(prefixRegEx);
                  var hasPrefix = prefixMatch !== null && prefixMatch.length > 0;
                  var filterOut = hasPrefix && prevStepVal !== prefixMatch[1];

                  $mfOpt.css('display', fstate.disabled ? 'none' : 'block');
                  if (fstate.disabled || filterOut) {
                    $mfOpt.addClass('optInvisible');
                  } else {
                    $mfOpt.removeClass('optInvisible');
                  }
                }
                if (fstate.checked) {
                  $mfSelect.val(fstate.value);
                  $mfSelect.trigger('change.select2');
                  filteredSteps++;
                  numSelections++;
                  prevStepVal = fstate.value;
                }
              });
            }
            $mfSelect.trigger('change.select2');
            filterStep++;
          }

          // Locking selection steps:
          var selnum = 0;
          for (var sp in CollectionFilterSpecs.selects) {
            if (CollectionFilterSpecs.selects.hasOwnProperty(sp)) {
              var select = CollectionFilterSpecs.selects[sp];
              var $mfSelect2 = $("#collection-metafilters select[name='metafilter_" + sp + "']");
              if (selnum <= numSelections) {
                $mfSelect2.next().removeClass('disabled');
                $mfSelect2.prop('disabled', false);
              } else {
                $mfSelect2.next().addClass('disabled');
                $mfSelect2.prop('disabled', 'disabled');
              }
              selnum++;
            }
          }

          // Sub-collections with assigned values, will alter locking:
          var selnum = 0;
          var unlockNext = false;
          for (var sp in CollectionFilterSpecs.selects) {
            if (CollectionFilterSpecs.selects.hasOwnProperty(sp)) {
              var select = CollectionFilterSpecs.selects[sp];
              var $mfSelect2 = $("#collection-metafilters select[name='metafilter_" + sp + "']");
              var lockedIn = CollectionFilterSpecs.lockedIn[sp];
              if (lockedIn) {
                //console.log(sp, lockedIn);
                unlockNext = true;
                var $visibleSelect = $mfSelect2.next();
                $visibleSelect.before('<div class="locked-filter">' + lockedIn + '</div>');
                $visibleSelect.hide();
                // Hide picker, release next one.
              } else if (unlockNext) {
                $mfSelect2.next().removeClass('disabled');
                $mfSelect2.prop('disabled', false);
              }
              selnum++;
            }
          }

          if (this.FILTER_DISABLE_NOTICE) {
            this.showSubstituteMessage();
          }

          // Filters populated, now check url for picks:
          this.applyUrlFiltering();
        },

        /* Meta Filter selection made: update base filters */
        onMetaFilterStateChange: function() {
          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.onMetaFilterStateChange'); }

          var setFilters = [];
          for (var sp in CollectionFilterSpecs.selects) {
            if (CollectionFilterSpecs.selects.hasOwnProperty(sp)) {
              var select = CollectionFilterSpecs.selects[sp];
              var $fSelect = $("#collection-metafilters select[name=metafilter_" + sp + "]");
              var baseFieldName = select.field;
              var selection = $fSelect.val();
              var $baseInputs = $("input[name='filter.p.m.custom." + sp + "']");
              $baseInputs.each(function() {
                var $cb = $(this);
                var thisVal = $cb.attr('value');
                var checked = $cb.prop('checked');
                if (thisVal == selection) {
                  $cb.prop('checked', true);
                } else {
                  $cb.prop('checked', false);
                }
              });
            }
          }

          let submitFilterEvent = new Event('submit-filters');
          document.querySelector('body').dispatchEvent(submitFilterEvent);
        },

        setFilterConstraints: function(ele) {
          var $ = this.$;

          var clickedFilterName = $(ele).attr('name').replace('metafilter_', '');

          var flush = false;
          var urlPath = [];
          for (var sp in CollectionFilterSpecs.selects) {
            if (CollectionFilterSpecs.selects.hasOwnProperty(sp)) {
              var $fSelect = $("#collection-metafilters select[name=metafilter_" + sp + "]");
              if (flush) {
                $fSelect.val('');
                var resetUrl = CollectionFilterSpecs.base_url + '?' + urlPath.join('&');
                window.location.href = resetUrl;
              }
              urlPath.push('filter.p.m.custom.' + sp + '=' + $fSelect.val());
              if (sp == clickedFilterName) {
                flush = true;
              }
            }
          }
        },

        /* When the filters change, match ours... */
        watchPageRenderEvent: function() {
          var $ = this.$;
          var self = this;
          $('body').on('filtering-renderactivefacets', (e) => {
            self.setMetaFilterState();
          });
        },

        /* On page scroll, float filters in header */
        filterFloat: function() {
          var self = this;
          var $ = self.$;

          if (!$) {
            return;
          }

          var $metaFilters = $("#collection-metafilters");

          var mcf = document.getElementById("main-collection-filters");
          var mcfOnScreen = AquaTechTheme.isOnScreen(mcf);
          if (!mcfOnScreen) {
            $metaFilters.addClass('floating');
            $('body').addClass('mcf-floating');
          } else {
            $metaFilters.removeClass('floating');
            $('body').removeClass('mcf-floating');
          }
        },

        onWindowScroll: function() {
          this.filterFloat();
        },

        /* Load Custom Reference Table */
        initCustomReferenceTables: function() {
          var self = this;

          var urlParts = AquaTechTheme.getUrlParts();
          var fetchUrl = self.CollectionTables[urlParts.path];
          if (fetchUrl) {
            CustLoadScript(fetchUrl, function() {
              self.onCustomReferenceTableLoad();
            });
          }
        },

        /* On reference table load, load any subtables and build the filter */
        onCustomReferenceTableLoad: function() {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.onCustomReferenceTableLoad'); }

          if (AquaTechTheme.CollectionFilter.CustomFilterField.subtable) {
            AquaTechTheme.CollectionFilter.primaryCFF = AquaTechTheme.CollectionFilter.CustomFilterField;
            AquaTechTheme.CollectionFilter.primaryCFT = AquaTechTheme.CollectionFilter.CustomFilterTable;
            var subtableUrl = self.CollectionTables[AquaTechTheme.CollectionFilter.primaryCFF.subtable];
            CustLoadScript(subtableUrl, function() {
              self.onSubReferenceTableLoad();
            });
          }

          self.renderCustomFilter();

          var parentFieldName = AquaTechTheme.CollectionFilter.CustomFilterField.parent;
          var $parentField = $("select[name='" + parentFieldName + "']");
          $parentField.on('change', function() {
            self.onCustomFilterParentChange();
          });
          self.onCustomFilterParentChange();

          self.initCustomPriorityTables();
        },

        /* On subtable load, swap primary back in, and render subtype filter */
        onSubReferenceTableLoad: function() {
          var self = this;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.onSubReferenceTableLoad'); }

          AquaTechTheme.CollectionFilter.subCustomFilterField = AquaTechTheme.CollectionFilter.CustomFilterField;
          AquaTechTheme.CollectionFilter.subCustomFilterTable = AquaTechTheme.CollectionFilter.CustomFilterTable;
          AquaTechTheme.CollectionFilter.CustomFilterField = AquaTechTheme.CollectionFilter.primaryCFF;
          AquaTechTheme.CollectionFilter.CustomFilterTable = AquaTechTheme.CollectionFilter.primaryCFT;
          delete AquaTechTheme.CollectionFilter.primaryCFF;
          delete AquaTechTheme.CollectionFilter.primaryCFT;

          self.renderSubTypeFilter();

          console.log('Subtable Loaded.');
        },

        /* Parent of Custom filter changed... */
        onCustomFilterParentChange: function() {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.onCustomFilterParentChange'); }

          var parentFieldName = AquaTechTheme.CollectionFilter.CustomFilterField.parent;
          var $parentField = $("select[name='" + parentFieldName + "']");

          var parentVal = $parentField.val();
          self.setCustomFilterFieldOptions(parentVal);
        },

        /* Render Custom filter */
        renderCustomFilter: function() {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.renderCustomFilter'); }

          var parentFieldName = AquaTechTheme.CollectionFilter.CustomFilterField.parent;
          var $parentField = $("select[name='" + parentFieldName + "']");

          var $parentDiv = $("#collection-metafilters .filter-stages");

          var $customSelect = $('<select name="fits_custom"></select>');
          $parentDiv.append($customSelect);

          $customSelect.select2({
            minimumResultsForSearch: Infinity,
            templateResult: function(data, container) {
              if (data.element) {
                $(container).addClass($(data.element).attr("class"));
              }
              return data.text;
            },
          }).data('select2').$dropdown.addClass('collection-metafilter-dropdown');

          $customSelect.on('change', function() {
            self.onCustomFilterChange();
          });
        },

        /* Populate Custom Filter */
        setCustomFilterFieldOptions: function(parentValue) {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.setCustomFilterFieldOptions(' + parentValue + ')'); }

          var $customSelect = $("#collection-metafilters .filter-stages select[name='fits_custom']");
          $customSelect.empty();
          $customSelect.append('<option value="">' + AquaTechTheme.CollectionFilter.CustomFilterField.label + '</option>');

          var numRows = AquaTechTheme.CollectionFilter.CustomFilterTable.length;
          var opts = {};
          for (var fi = 0; fi < numRows; fi++) {
            var row = AquaTechTheme.CollectionFilter.CustomFilterTable[fi];
            if (row.parent == parentValue) {
              var pid = row.product_id;
              var label = row.label;
              if (!opts[label]) {
                opts[label] = [];
              }
              opts[label].push(pid);
            }
          }

          for (var optLabel in opts) {
            if (opts.hasOwnProperty(optLabel)) {
              var pids = opts[optLabel];
              $customSelect.append('<option value="' + pids.join('|') + '">' + optLabel + '</option>');
            }
          }

          setTimeout(function() {
            $customSelect.trigger('change');
          }, 100);

          if (parentValue) {
            $customSelect.next().removeClass('disabled');
            $customSelect.prop('disabled', false);

          } else {
            $customSelect.next().addClass('disabled');
            $customSelect.prop('disabled', 'disabled')
          }
        },

        /* Custom Filter changed... */
        onCustomFilterChange: function() {
          var self = this;
          var $ = self.$;

          var $productPanels = $('#CollectionProductGrid .collection-main-body-inner > .grid__item');
          $productPanels.removeClass('suppress');

          var $customSelect = $("#collection-metafilters .filter-stages select[name='fits_custom']");
          var showProductStr = $customSelect.val();
          var showProductIds = showProductStr.split('|');

          $('#CollectionProductGrid .collection-main-body-inner');
          var $productPanels = $('#CollectionProductGrid .collection-main-body-inner > .grid__item');

          if (showProductStr) {
            $productPanels.each(function() {
              var $pp = $(this);
              var productId = $pp.attr('data-productid');
              if (showProductIds.includes(productId)) {
                $pp.show();
                $pp.removeClass('suppress');
                $pp.css('visibility', 'visible');
              } else {
                $pp.hide();
                $pp.addClass('suppress');
              }
            });

          } else {
            $productPanels.show();
          }

          self.updateAllProductsVisibility();
        },

        /* Load priority tables */
        initCustomPriorityTables: function() {
          var self = this;

          var urlParts = AquaTechTheme.getUrlParts();
          var fetchUrl = self.PriorityTables[urlParts.path];
          if (fetchUrl) {
            if (fetchUrl == 'filter') {
              console.log('priority in filter file...');
              self.onCustomPriorityTableLoad();

            } else {
              CustLoadScript(fetchUrl, function() {
                self.onCustomPriorityTableLoad();
              });
            }
          }
        },

        /* Priority table loaded, sort */
        onCustomPriorityTableLoad: function() {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.onCustomPriorityTableLoad'); }

          if (!AquaTechTheme.CollectionFilter.CustomFilterPriorityField) {
            return;
          }

          var parentFieldName = AquaTechTheme.CollectionFilter.CustomFilterPriorityField.parent;

          if (AquaTechTheme.CollectionFilter.CustomFilterParentPriorityList) {
            self.orderCustomFilterPriorityParentFieldOptions(parentFieldName);
          }

          var $parentField = $("select[name='" + parentFieldName + "']");
          $parentField.on('change', function() {
            self.onCustomPriorityFilterParentChange();
          });
          self.onCustomPriorityFilterParentChange();
        },

        /* Parent of Custom filter changed */
        onCustomPriorityFilterParentChange: function() {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.onCustomPriorityFilterParentChange'); }

          var parentFieldName = AquaTechTheme.CollectionFilter.CustomFilterPriorityField.parent;
          var $parentField = $("select[name='" + parentFieldName + "']");

          var parentVal = $parentField.val();
          self.orderCustomFilterPriorityFieldOptions(parentVal);
        },

        /* Reorder custom filter by priority list */
        orderCustomFilterPriorityFieldOptions: function(parentValue) {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.orderCustomFilterPriorityFieldOptions(' + parentValue + ')'); }

          if (!AquaTechTheme.CollectionFilter.CustomFilterPriorityList) {
            return;
          }

          var parentFieldName = AquaTechTheme.CollectionFilter.CustomFilterPriorityField.parent;
          var $baseSelect = $("select[name='" + AquaTechTheme.CollectionFilter.CustomFilterPriorityField.select + "']");

          var priorityList = AquaTechTheme.CollectionFilter.CustomFilterPriorityList;
          var pPos = 1;
          for (var pli = 0; pli < priorityList.length; pli++) {
            var optVal = priorityList[pli];
            var $moveChild = $baseSelect.find("option[value='" + optVal + "']");
            if ($moveChild.length == 0) {
              if (this.DEBUG) { console.log("'" + optVal + "' not found in filter list"); }
              continue;
            }
            var $preChild = $baseSelect.find("option:nth-child(" + pPos + ")");
            if ($preChild.val() !== optVal) {
              $preChild.after($moveChild);
            }
            pPos++;
          }
        },

        /* Reorder parent of Custom filter by priority list */
        orderCustomFilterPriorityParentFieldOptions: function(parentFieldName) {
          var self = this;
          var $ = self.$;

          var $baseSelect = $("select[name='" + parentFieldName + "']");

          var priorityList = AquaTechTheme.CollectionFilter.CustomFilterParentPriorityList;
          var pPos = 1;
          for (var pli = 0; pli < priorityList.length; pli++) {
            var optVal = priorityList[pli];
            var $moveChild = $baseSelect.find("option[value='" + optVal + "']");
            if ($moveChild.length == 0) {
              continue;
            }
            var $preChild = $baseSelect.find("option:nth-child(" + pPos + ")");
            if ($preChild.val() !== optVal) {
              $preChild.after($moveChild);
            }
            pPos++;
          }
        },

        /* Construct subtype filter ('Lens Port Style') */
        renderSubTypeFilter: function() {
          var self = this;
          var $ = self.$;

          if (this.DEBUG) { console.log('AquaTechTheme.CollectionFilter.renderSubTypeFilter()'); }

          var label = AquaTechTheme.CollectionFilter.CustomFilterField.subtype_label;
          var $parentDiv = $("#collection-metafilters .filter-stages");

          var $customSelect = $('<select name="fits_subtype"></select>');
          $parentDiv.append($customSelect);

          $customSelect.append('<option value="">' + label + '</option>');
          self.populateSubTypes($customSelect);

          $customSelect.select2({
            minimumResultsForSearch: Infinity,
            templateResult: function(data, container) {
              if (data.element) {
                $(container).addClass($(data.element).attr("class"));
              }
              return data.text;
            },
          }).data('select2').$dropdown.addClass('collection-metafilter-dropdown');

          $customSelect.next().addClass('disabled');
          $customSelect.prop('disabled', 'disabled');

          if (AquaTechTheme.RecommendationsEnabled) {
            $customSelect.on('change', function() {
              var matchedRows = self.onSubTypeFilterChange();

              var $subtypeSelect = $("select[name='fits_subtype']");
              var subtypeSelection = $subtypeSelect.val();
              if (subtypeSelection) {
                self.recommendProducts(matchedRows);
              }
            });
          }

          jQuery(window).scroll(function() {
            setTimeout(function() {
              self.onSubTypeFilterChange(); // scroll fix
            }, 100);
          });

          var $parentFilter = $("select[name='" + AquaTechTheme.CollectionFilter.CustomFilterField.subtype_parent_field + "']");
          $parentFilter.on('change', function() {
            self.onSubTypeParentFilterChange();
          });
          self.onSubTypeParentFilterChange();
        },

        /* Populate subtype filter */
        populateSubTypes: function($customSelect) {
          var self = this;

          var numRows = AquaTechTheme.CollectionFilter.CustomFilterTable.length;
          var opts = [];
          for (var fi = 0; fi < numRows; fi++) {
            var row = AquaTechTheme.CollectionFilter.CustomFilterTable[fi];
            if (opts.indexOf(row.subtype) == -1) {
              opts.push(row.subtype);
            }
          }

          for (var oi = 0; oi < opts.length; oi++) {
            var okv = opts[oi];
            $customSelect.append('<option value="' + okv + '">' + okv + '</option>');
          }
        },

        /* Custom filter changed, update subtype filter */
        onSubTypeParentFilterChange: function() {
          var self = this;
          var $ = self.$;

          var $parentFilterSelect = $("select[name='" + AquaTechTheme.CollectionFilter.CustomFilterField.subtype_parent_field + "']");
          var $subtypeSelect = $("select[name='fits_subtype']");

          $subtypeSelect.val('');
          $subtypeSelect.trigger('change.select2');

          if ($parentFilterSelect.val()) {
            $subtypeSelect.next().removeClass('disabled');
            $subtypeSelect.prop('disabled', false);
          } else {
            $subtypeSelect.next().addClass('disabled');
            $subtypeSelect.prop('disabled', 'disabled');
          }

          self.clearRecommendations();
        },

        /* Subtype filter changed, determine what to display and recommend */
        onSubTypeFilterChange: function() {
          var self = this;
          var $ = self.$;

          var $subtypeSelect = $("select[name='fits_subtype']");
          var subtypeSelection = $subtypeSelect.val();

          var $grandParentSelect = $("select[name='" + AquaTechTheme.CollectionFilter.CustomFilterField.parent + "']");
          var grandParentSelection = $grandParentSelect.find(' option:selected').text();
          var $parentFilterSelect = $("select[name='" + AquaTechTheme.CollectionFilter.CustomFilterField.subtype_parent_field + "']");
          var parentSelection = $parentFilterSelect.find(' option:selected').text();
          var productSelections = $parentFilterSelect.val().split('|');
          var parentRowProperty = AquaTechTheme.CollectionFilter.CustomFilterField.subtype_parent_prop;

          var suppressProducts = [];
          var revealProducts = [];
          var matchedRows = [];

          var numRows = AquaTechTheme.CollectionFilter.CustomFilterTable.length;
          var opts = [];
          for (var fi = 0; fi < numRows; fi++) {
            var row = AquaTechTheme.CollectionFilter.CustomFilterTable[fi];
            if (row.parent !== grandParentSelection) {
              continue;
            }

            if (!row[parentRowProperty] || row[parentRowProperty] !== parentSelection) {
              continue;
            }

            if (!subtypeSelection) {
              revealProducts.push(row.product_id);
              matchedRows.push(row);

              self.clearRecommendations();
            }

            if (row.subtype !== subtypeSelection) {
              suppressProducts.push(row.product_id);
              continue;
            }

            revealProducts.push(row.product_id);
            matchedRows.push(row);
          }

          self.toggleSubTypeProducts(suppressProducts, revealProducts);

          self.updateAllProductsVisibility();

          return matchedRows;
        },

        /* Show/hide -all- products based on stages of filter selection */
        updateAllProductsVisibility: function() {
          var self = this;
          var $ = self.$;

          var $productPanels = $('#CollectionProductGrid');

          var $filterStageSelects = $(".filter-stages select");
          var numSelected = 0;
          $filterStageSelects.each(function() {
            var $select = $(this);
            if ($select.val()) {
              numSelected++;
            }
          });

          var $messagePanel = $('.product-recommendations-messages');

          if (numSelected == 0 || numSelected == $filterStageSelects.length) {
            $productPanels.removeClass('suppressed');
            $messagePanel.hide();

          } else {
            $productPanels.addClass('suppressed');
            $messagePanel.html('Select all filter options to show relevant products.');
            $messagePanel.show();
          }
        },

        /* Show/hide products based on Subtype select */
        toggleSubTypeProducts: function(suppressProducts, revealProducts) {
          var self = this;
          var $ = self.$;

          var $productPanels = $('#CollectionProductGrid .collection-main-body-inner > .grid__item');
          $productPanels.each(function() {
            var $pp = $(this);
            var productId = $pp.attr('data-productid');
            if (revealProducts.includes(productId)) {
              $pp.show();
              $pp.css('visibility', 'visible');
            } else if (suppressProducts.includes(productId)) {
              $pp.hide();
            }
          });
        },

        cachedProducts: [],
        cachedVariants: [],
        productsToRecommend: [],

        /* Determine products to recommend, and load... */
        recommendProducts: function(matchedRows) {
          var self = this;
          var $ = self.$;

          self.productsToRecommend = [];

          // Primary table:
          var numMRows = matchedRows.length;
          for (var mi = 0; mi < numMRows; mi++) {
              var mrow = matchedRows[mi];
              self.productsToRecommend.push({
                'product_id': mrow.product_id,
                'variant_id': mrow.variant_id,
                'subset': mrow.subset,
                'is_alt_to' : mrow.is_alt_to
              });
          }

          // Subtable:

          var $parentFilterSelect = $("select[name='" + AquaTechTheme.CollectionFilter.CustomFilterField.subtable_match_parent + "']");
          var $parentSelectedOption = $parentFilterSelect.find(' option:selected');
          if (!$parentSelectedOption.length || $parentSelectedOption.val() == '') {
            self.renderRecommendations();
            return;
          }
          var parentSelection = $parentSelectedOption.text();

          var subTableMatchField = AquaTechTheme.CollectionFilter.CustomFilterField.subtable_match;
          var $fitsMountsField = $("select[name='metafilter_fits_mounts']");
          var mount = $fitsMountsField.val();
          var matchBrand = mount.split(' ')[0]; // match brand vs first word of mount name

          var numRows = AquaTechTheme.CollectionFilter.subCustomFilterTable.length;
          var opts = [];
          for (var fi = 0; fi < numRows; fi++) {
            var row = AquaTechTheme.CollectionFilter.subCustomFilterTable[fi];
            var isBrandMatch = matchBrand == row['parent'];
            if (row[subTableMatchField] && isBrandMatch && row[subTableMatchField] == parentSelection) {
              self.productsToRecommend.push({
                'product_id': row.product_id,
                'variant_id': row.variant_id,
                'subset': null
              });
            }
          }

          self.loadNextRecommendation();
        },

        /* Ajax Fetch product data by id */
        getProductData: function(productId) {
          var self = this;
          var $ = self.$;

          console.log('Fetch ' + productId + '...');

          if (self.cachedProducts[productId] && self.cachedProducts[productId] !== 'fail') {
            // Cached:
            self.onRecommendationLoaded();
            return;
          }

          $.ajax({
            url: "/search/suggest.json?q=id:" + productId + "&resources[type]=product&limit=1&resources[options][unavailable_products]=show",
            type: 'GET',
            success: function(response) {
              self.onProductDataGet(response);
            },
            error: function(xhr, ajaxOptions, thrownError) {
              self.cachedProducts[productId] = 'fail';
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        /* Product initial date get, Ajax fetch the rest */
        onProductDataGet: function(response) {
          var self = this;

          var results = response.resources.results.products;
          var product = results[0];

          if (!product) {
            self.showProductError('Could not find matching product(s)');
            return;
          }

          var url = product.url;
          var parts = url.split('?');
          product.slug = parts[0].replace('/products/', '');

          self.cachedProducts[product.id] = product;

          $.ajax({
            url: "/products/" + product.slug + ".json",
            type: 'GET',
            success: function(response2) {
              self.onProductFullDataGet(response2);
            },
            error: function(xhr, ajaxOptions, thrownError) {
              self.cachedProducts[productId] = 'fail';
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        showProductError: function(message) {
          var self = this;
          var $ = self.$;

          var $recommendPanel = $('.product-recommendations');
          $recommendPanel.html('<p class="error">' + message + '</p>');
        },

        /* Product rest of data fetched, store variant */
        onProductFullDataGet: function(response) {
          var self = this;

          var product = response.product;
          var firstVariant = response.product.variants[0].id;
          self.cachedProducts[product.id].default_variant_id = firstVariant;
          self.cachedProducts[product.id].variantdata = product.variants;

          self.onRecommendationLoaded();
        },

        /* On recommendation load, load another */
        onRecommendationLoaded: function() {
          var self = this;

          self.loadNextRecommendation();
        },

        /* Load the next uncached recommended product */
        loadNextRecommendation: function() {
          var self = this;
          var $ = self.$;

          for (var pi = 0; pi < self.productsToRecommend.length; pi++) {
            var prod = self.productsToRecommend[pi];
            if (!self.cachedProducts[prod.product_id]) {
              self.getProductData(prod.product_id);
              return;
            }
          }

          self.renderRecommendations();
        },

        cachedCartProducts: [],

        /* Ajax Fetch cart contents */
        getCart: function(callback) {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart.json",
            type: 'GET',
            success: function(response) {
              self.parseCart(response, callback);
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        /* Extract product & variant ids from cart */
        parseCart: function(response, callback) {
          var self = this;

          self.cachedCartProducts = [];

          for (var ci = 0; ci < response.items.length; ci++) {
            var item = response.items[ci];
            self.cachedCartProducts[item.product_id] = {
              variant_id: item.variant_id,
              qty: item.quantity
            }
          }

          callback();
        },

        subSets: [],

        /* Render fetched recommendations as panels + total */
        renderRecommendations: function() {
          var self = this;
          var $ = self.$;

          if (self.productsToRecommend.length == 0) {
            self.clearRecommendations();
          }

          var $recommendPanel = $('.product-recommendations');
          $recommendPanel.html('');

          var $title = $('<div class="product-recommend-title">Here\'s your setup - Lens Port, Adapter, and Zoom Gear</div>');
          $recommendPanel.append($title);

          var $prPanel = $('<div class="product-recommend-panel"></div>');
          $recommendPanel.append($prPanel);

          var singleNonPrimary = (self.productsToRecommend.length == 1) && (self.productsToRecommend[0].subset == null);

          if (self.productsToRecommend.length == 0 || singleNonPrimary) {
            var $subtypeSelect = $("select[name='fits_subtype']");
            var subtypeSelection = $subtypeSelect.val();

            $recommendPanel.html('<p class="no-recommendation">Not available in a ' + subtypeSelection + ' configuration.</p>');
          }

          if (!self.productsToRecommend) {
            return;
          }

          self.subsets = [];
          for (var spi = 0; spi < self.productsToRecommend.length; spi++) {
            var subset = self.productsToRecommend[spi].subset;
            if (subset && self.subsets.indexOf(subset) == -1) {
              self.subsets.push(subset);
            }
          }

          for (var si = 0; si < self.subsets.length; si++) {
            var pSubset = self.subsets[si];
            var $bundleTitle = $('<div class="bundle-title">' + self.subsetGroups[pSubset] + '</div>');
            $prPanel.append($bundleTitle);
            var $bundle = $('<div class="product-recommend-bundle" data-subset="' + pSubset + '">');
            $prPanel.append($bundle);

            for (var pi = 0; pi < self.productsToRecommend.length; pi++) {
              var productSpec = self.productsToRecommend[pi];

              if (productSpec.subset && productSpec.subset !== pSubset) {
                continue;
              }

              var productData = self.cachedProducts[productSpec.product_id];
              var productHtml = self.recommendedProductHtml(productSpec, productData);
              var $productPanel = $(productHtml);

              var $addToCart = $productPanel.find('.add-to-cart .button');
              $addToCart.on('click', function(e) {
                e.preventDefault();
                self.addToCartSingle($(this));
              });

              var $selectToggle = $productPanel.find('.select-toggle');
              $selectToggle.on('click', function(e) {
                e.preventDefault();
                var $selectedProductPanel = $(this).closest('.recommend-product.recommended');
                self.toggleRecommendSelect($selectedProductPanel);
              });

              $bundle.append($productPanel);
            }

            var $totalPanel = $(self.totalProductsHtml());
            $bundle.append($totalPanel);
            var $addSelectedButton = $totalPanel.find('.add-to-cart .button');
            $addSelectedButton.on('click', function(e) {
              e.preventDefault();
              self.addToCartSelected($(this));
            });

            var $selectToggle = $totalPanel.find('.select-toggle');
            $selectToggle.on('click', function(e) {
              e.preventDefault();
              self.toggleSelectAll($(this));
            });
          }

          $recommendPanel.addClass('visible');

          self.applyCurrentSelectionBookmark();

          self.updateRecommendationsCartState();
        },

        updateRecommendationsCartState: function() {
          var self = this;
          var $ = self.$;

          self.getCart(self.updateRecommendationsCartFetched);
        },

        updateRecommendationsCartFetched: function() {
          var self = AquaTechTheme.CollectionFilter;
          var $ = self.$;

          if (!self.subsets) {
            return;
          }

          for (var si = 0; si < self.subsets.length; si++) {
            var subset = self.subsets[si];
            var $bundle = $(".product-recommend-bundle[data-subset='" + subset + "']");
            var $products = $bundle.find('.recommend-product.recommended');
            $products.each(function() {
              var $product = $(this);
              var $button = $product.find('.add-to-cart .button');
              var available = $button.parent().hasClass('out-of-stock') == false;
              if (available) {
                $button.removeClass('disabled');
                $button.html('Add to cart');
              } else {
                $button.addClass('disabled');
                $button.html('Out of stock');
              }
            });
          }

          for (var prodId in self.cachedCartProducts) {
            if (self.cachedCartProducts.hasOwnProperty(prodId)) {
              var variantId = self.cachedCartProducts[prodId].variant_id;
              var $matchRecommendation = $(".recommend-product.recommended[data-variant-id='" + variantId + "']");
              $matchRecommendation.addClass('in-cart');
              var $button = $matchRecommendation.find('.add-to-cart .button');
              $button.addClass('disabled');
              $button.html('In cart');
              $matchRecommendation.attr('data-selected', '');
              var $select = $matchRecommendation.find('.select-toggle');
              $select.removeClass('selected');
            }
          }

          self.updateRecommendedTotals();
        },

        toggleRecommendSelect: function($productPanel, setState) {
          var self = this;
          var $ = self.$;

          var state = $productPanel.attr('data-selected');
          var $stateToggle = $productPanel.find('.select-toggle');

          var newState = state == '' ? 'selected' : '';
          if (setState) {
            newState = setState;
          }

          if (newState == 'selected') {
            $productPanel.attr('data-selected', 'selected');
            $stateToggle.addClass('selected');
          } else {
            $productPanel.attr('data-selected', '');
            $stateToggle.removeClass('selected');
          }

          self.updateRecommendedTotals();
        },

        /* Calculate cart total */
        updateRecommendedTotals: function() {
          var self = this;
          var $ = self.$;

          for (var si = 0; si < self.subsets.length; si++) {
            var subset = self.subsets[si];
            var $bundle = $(".product-recommend-bundle[data-subset='" + subset + "']");
            var $products = $bundle.find('.recommend-product.recommended');
            var $total = $bundle.find('.recommend-product.totals');

            var totalPrice = 0;
            var numSelected = 0;
            $products.each(function() {
              var $product = $(this);
              if ($product.attr('data-selected') == 'selected') {
                totalPrice += parseFloat($product.data('price'));
                numSelected++;
              }
            });
            totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
            $total.find('.total .price').html('$' + totalPrice);

            var $totalAddToCart = $total.find('.add-to-cart .button');
            if (numSelected > 0) {
              $totalAddToCart.html('Add selected to cart').removeClass('disabled');
            } else {
              $totalAddToCart.html('No selection').addClass('disabled');
            }
          }
        },

        /* Wipe and hide recommendations panel */
        clearRecommendations: function() {
          var self = this;
          var $ = self.$;

          var $recommendPanel = $('.product-recommendations');
          $recommendPanel.html('');
          $recommendPanel.removeClass('visible');
        },

        /* HTML for recommended product panel */
        recommendedProductHtml: function(productSpec, productData) {
          var self = this;

          var imgSrc = productData.image;
          imgSrc = imgSrc.replace('.jpg', '_550x.jpg');
          imgSrc = imgSrc.replace('.jpeg', '_550x.jpeg');
          imgSrc = imgSrc.replace('.png', '_550x.png');

          var title = productData.title;

          var productId = productData.id;
          var url = productData.url;
          var variantId = (productSpec.variant_id && productSpec.variant_id !== productSpec.product_id) ? productSpec.variant_id : productData.default_variant_id;

          var variant = self.findProductVariant(productData, variantId);
          var variantTitle = self.productVariantName(productData, variantId);
          var variantTitleStr = variantTitle ? '<span class="variant-title">' + variantTitle + '</span>' : '';
          var variantPrice = variant.price;

          var available = productData.available;

          var price = parseFloat(variantPrice);
          price = (Math.round(price * 100) / 100).toFixed(2);
          var caPrice = parseFloat(productData.compare_at_price_max);
          caPrice = (Math.round(caPrice * 100) / 100).toFixed(2);
          var priceDisplay = '<span class="money">$' + price + '</span>';
          if (caPrice > price) {
            priceDisplay = '<span class="money price-line-through sale-price">$' + caPrice + '</span>' +
                           priceDisplay;
          }

          var addToCartHtml = '<div class="add-to-cart"><a class="button">Add to cart</a></div>';
          var toggleSelect = '<a class="select-toggle selected">' + self.tickSvg + '</a>';
          var dataSelected = ' data-selected="selected"';
          if (!available) {
            addToCartHtml = '<div class="add-to-cart out-of-stock"><span class="button disabled">Out of Stock</span></div>';
            toggleSelect = '';
            dataSelected = ' data-selected=""';
          }

          var option = '';
          if (productSpec.is_alt_to) {
            option = 'Alternative for ' + productSpec.is_alt_to;
            dataSelected = ' data-selected=""';
            toggleSelect = '<a class="select-toggle">' + self.tickSvg + '</a>';
          }

          var html =
            '<div class="recommend-product recommended" data-product-id="' + productId + '" data-variant-id="' + variantId + '" data-base-price="' + price + '" data-price="' + variantPrice + '" data-available="' + available + '"' + dataSelected + '><div class="inner">' +
              '<div class="image"><a href="' + url + '"><img src="' + imgSrc + '" width="550" /></a></div>' +
              '<div class="detail">' +
                '<div class="option">' + option + '</div>' +
                '<div class="title">' +
                  '<span class="product-title">' + title + '</span>' +
                  variantTitleStr +
                '</div>' +
                '<div class="price">' + priceDisplay + '</div>' +
              '</div>' +
              addToCartHtml +
              toggleSelect +
              '<span class="error" style="display: none;">Out of Stock</span>' +
            '</div></div>';

          return html;
        },

        /* Locate variant title in product variant data */
        productVariantName: function(productData, variantId) {
          var variants = productData.variantdata;
          for (var vi = 0; vi < variants.length; vi++) {
            var variant = variants[vi];
            if (variant.id == variantId && variant.title !== 'Default Title') {
              return variant.title;
            }
          }

          return null;
        },

        productVariantPrice: function(productData, variantId) {
          var variants = productData.variantdata;
          for (var vi = 0; vi < variants.length; vi++) {
            var variant = variants[vi];
            if (variant.id == variantId) {
              return variant.price;
            }
          }

          return null;
        },

        findProductVariant: function(productData, variantId) {
          var variants = productData.variantdata;
          for (var vi = 0; vi < variants.length; vi++) {
            var variant = variants[vi];
            if (variant.id == variantId) {
              return variant;
            }
          }

          return null;
        },

        /* HTML for recommendatons total panel */
        totalProductsHtml: function() {
          var self = this;

          var html =
            '<div class="recommend-product totals"><div class="inner">' +
              '<div class="total">' +
              '<div class="label">Total Price</div>' +
              '<div class="price">$XXX.XX</div>' +
              '</div>' +
              '<div class="add-to-cart"><a class="button">Add selected to cart</a></div>' +
              '<a class="select-toggle">' + self.tickSvg + '</a>' +
            '</div></div>';

          return html;
        },

        /* Checkmark symbol */
        tickSvg: '<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"> <path d="M5.5 13L9.5 17L19.5 7" stroke="#1077f1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg>',

        /* Add to cart from single button click */
        addToCartSingle: function($button) {
          var self = this;
          var $ = self.$;

          var $selectedProductPanel = $button.closest('.recommend-product.recommended');
          var variantId = $selectedProductPanel.attr('data-variant-id');

          var formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };

          self.addToCartPost(formData, function() {
            self.addedSingleToCart($button);
          });
        },

        addedSingleToCart: function($addButton) {
          window.wetheme.toggleRightDrawer();
        },

        /* Add selected products in bundle to cart button click */
        addToCartSelected: function($addAllButton) {
          var self = this;
          var $ = self.$;

          var $bundle = $addAllButton.closest('.product-recommend-bundle');
          var $selectedProducts = $bundle.find(".recommend-product.recommended[data-selected='selected']");

          var items = [];
          $selectedProducts.each(function() {
            var $selectedProductPanel = $(this);
            var variantId = $selectedProductPanel.attr('data-variant-id');
            items.push({
              'id': variantId,
              'quantity': 1
            });
          });

          var formData = {
            'items': items
          };

          self.addToCartPost(formData, function() {
            self.addedSelectionToCart($addAllButton);
          });
        },

        addedSelectionToCart: function($addAllButton) {
          var self = this;

          var $totals = $('.recommend-product.totals');

          $addAllButton.html('Added to cart');

          window.wetheme.toggleRightDrawer();
        },

        toggleSelectAll: function($selectToggle) {
          var self = this;
          var $ = self.$;

          var $bundle = $selectToggle.closest('.product-recommend-bundle');
          var $productPanels = $bundle.find(".recommend-product.recommended");
          var hasSelections = false;
          var everythingSelected = true;
          $productPanels.each(function() {
              var $productPanel = $(this);
              var available = $productPanel.attr('data-available') == 'true';
              var selected = $productPanel.attr('data-selected') == 'selected';
              if (available && !selected) {
                everythingSelected = false;
              }
          });

          $productPanels.each(function() {
              var $productPanel = $(this);
              if ($productPanel.attr('data-available') == 'true') {
                if (everythingSelected) {
                  self.toggleRecommendSelect($productPanel, '');
                } else  {
                  self.toggleRecommendSelect($productPanel, 'selected');
                }
              }
          });
        },

        /* ajax POST add to cart data */
        addToCartPost: function(formData, callback) {
          var self = this;

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            if (!data.status) {
              if (callback) {
                callback();
              }
              self.triggerCartUpdate();
            } else {
              console.log(data.description);
              alert(data.description);
            }
          })
          .catch((error) => {
            console.log('Error:', error);
          });
        },

        /* Watch for cart mutation: */
        watchCart: function() {
          document.documentElement.addEventListener('wetheme-cart-update', (event) => {
            console.log('Cart updated.');
            AquaTechTheme.CollectionFilter.updateRecommendationsCartState();
          })
        },

        /* Trigger cart update event */
        triggerCartUpdate: function() {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart?view=compare",
            type: 'GET',
            success: function(response) {
              var e = JSON.parse(response);
              window.wetheme.updateCartDrawer(e);
              var cartEvent = new CustomEvent("wetheme-cart-update", {
                  detail: {
                      cart: e
                  }
              });
              document.documentElement.dispatchEvent(cartEvent);

              console.log('Update Cart');
              window.THEME_CART_HOOK.fetchCart();
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        fetchCart: async function() {
            try {
                const languageUrl = document.getElementById("PageContainer").dataset.languageUrl;
                const e = languageUrl && "/" != languageUrl ? languageUrl : "",
                    t = await window.fetch(`${e}/cart?view=compare`);
                t.ok;
                const n = await t.json();
                this.cart = n, n.attributes.gift_note && (this.giftNote = n.attributes.gift_note), this.theme.updateCartDrawer(n)
            } catch (e) {
                console.error("Unable to fetch cart: ", e)
            }
        },

        pickSelectByOptionLabel: function(selectName, labelText) {
            var self = this;
            var $ = self.$;

            var $select = $("select[name='" + selectName + "']");
            $select.find("option").filter(function(index) {
                return labelText === $(this).text();
            }).attr("selected", "selected");
            Cookies.remove('cf_' + selectName);
            $select.trigger('change');
        },

        filterSelectionUrl: function() {
            var self = this;
            var $ = self.$;

            var $selFitsMounts = $("select[name='metafilter_fits_mounts']");
            var isPickedFitsMounts = $selFitsMounts.val();
            var pickFitsMounts = $selFitsMounts.find('option:selected').text();

            var $selFitsCustom = $("select[name='fits_custom'");
            var isPickedFitsCustom = $selFitsCustom.val();
            var pickFitsCustom = $selFitsCustom.find('option:selected').text();

            var $selFitsSubtype = $("select[name='fits_subtype']");
            var isPickedFitsSubtype = $selFitsSubtype.val();
            var pickFitsSubtype = $selFitsSubtype.find('option:selected').text();

            //console.log(isPickedFitsMounts ? pickFitsMounts : '', isPickedFitsCustom ? pickFitsCustom : '', isPickedFitsSubtype ? pickFitsSubtype : '');

            if (isPickedFitsMounts && isPickedFitsCustom && isPickedFitsSubtype) {
                var urlBase = location.protocol + '//' + location.host + location.pathname;
                var url = urlBase + '?cf_fits_mounts='
                        + pickFitsMounts.replaceAll(' ', '+')
                        + '&cf_fits_custom=' + pickFitsCustom.replaceAll(' ', '+')
                        + '&cf_fits_subtype=' + pickFitsSubtype.replaceAll(' ', '+');
                return url;
            }

            return false;
        },

        filterSelectByUrlParams: function() {
            var self = this;
            var $ = self.$;

            var urlPickFitsMounts = AquaTechTheme.getUrlParameter('cf_fits_mounts');
            Cookies.set('cf_metafilter_fits_mounts', urlPickFitsMounts);
            var urlPickFitsCustom = AquaTechTheme.getUrlParameter('cf_fits_custom');
            Cookies.set('cf_fits_custom', urlPickFitsCustom);
            var urlPickFitsSubType = AquaTechTheme.getUrlParameter('cf_fits_subtype');
            Cookies.set('cf_fits_subtype', urlPickFitsSubType);
        },

        applyCookieFilters: function() {
            var self = this;
            var nativeUrlMountParam = AquaTechTheme.getUrlParameter('filter.p.m.custom.fits_mounts');
            var urlPickFitsMounts = Cookies.get('cf_metafilter_fits_mounts');
            if (urlPickFitsMounts) {
                Cookies.remove('cf_metafilter_fits_mounts');
                var pickLabel = urlPickFitsMounts.replaceAll('+', ' ');
                if (!nativeUrlMountParam) { // Recursion guard
                  self.pickSelectByOptionLabel('metafilter_fits_mounts', pickLabel);
                  return;
                }
            }

            var urlPickFitsCustom = Cookies.get('cf_fits_custom');
            if (urlPickFitsCustom) {
                var pickLabel = urlPickFitsCustom.replaceAll('+', ' ');
                self.pickSelectByOptionLabel('fits_custom', pickLabel);
            }

            var urlPickFitsSubType = Cookies.get('cf_fits_subtype');
            if (urlPickFitsSubType) {
                var pickLabel = urlPickFitsSubType.replaceAll('+', ' ');
                self.pickSelectByOptionLabel('fits_subtype', pickLabel);
            }
        },

        applyUrlFiltering: function() {
            var self = this;

            // Note: Only works for water-housings-lens-ports-x-series-lens-ports filters right now.

            var urlPickFitsMounts = Cookies.get('cf_metafilter_fits_mounts');
            var urlPickFitsCustom = Cookies.get('cf_fits_custom');
            var urlPickFitsSubType = Cookies.get('cf_fits_subtype');

            if (urlPickFitsMounts || urlPickFitsCustom || urlPickFitsSubType) {
                self.applyCookieFilters();
            } else {
                self.filterSelectByUrlParams();
                self.applyCookieFilters();
            }
        },

        initClipboard: function() {
            var self = this;

            if (self.clipboard) {
                self.clipboard.destroy();
            }

            self.clipboard = new ClipboardJS('.btn-clipboard');
        },

        applyCurrentSelectionBookmark: function() {
            var self = this;
            var $ = self.$;

            var $insertPoint = $("#collection-metafilters");
            var $bookmark = $insertPoint.find('.bookmark');
            if (!$bookmark.length) {
              $insertPoint.append('<span class="bookmark"></span>');
              $bookmark = $insertPoint.find('.bookmark');
            }

            var url = self.filterSelectionUrl();
            if (url) {
              $bookmark.html('<button class="btn-clipboard" data-clipboard-action="copy" data-clipboard-text="' + url + '" title="Copy selection URL to clipboard"><i class="far fa-copy"></i></button>');
              self.initClipboard();
            } else {
              $bookmark.html('...');
            }
        }
    };

    AquaTechTheme.$(function() { AquaTechTheme.CollectionFilter.onDocReady(); });
    jQuery(window).scroll(function() { AquaTechTheme.CollectionFilter.onWindowScroll(); });
});
